import Vue from 'vue'
import Upload from '@/components/Upload'
import Apps from '@/components/Apps'
import Search from '@/components/Search'
import MPTM from '@/components/MPTM'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Help from '@/components/Help'
import Login from '@/components/Login'
import LoginBack from '@/components/LoginBack'
import LoginOauth from '@/components/LoginOauth'
import Register from '@/components/Register'
import Profile from '@/components/Profile'
import Forget from '@/components/Forget'
import ResetPassword from '@/components/ResetPassword'
import page404 from '@/components/404'
import confirm from '@/components/Confirm'
import LiteratureTrends from '@/components/LiteratureTrends'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/mptm',
      name: 'MPTM',
      component: MPTM

    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/literature_trends',
      redirect: '/literature_trends/newest',
      component: LiteratureTrends
    },
    {
      path: '/literature_trends/:id',
      component: LiteratureTrends,
      name: 'literature_trends'
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
      path: '/upload',
      name: 'upload',
      component: Upload
    },
    {
      path: '/apps',
      name: 'apps',
      component: Apps
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {auth: false}
    },
    {
      path: '/callback',
      name: 'loginback',
      component: LoginBack,
      meta: {auth: false}
    },
    {
      path: '/loginoauth',
      name: 'loginoauth',
      component: LoginOauth,
      meta: {auth: false}
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {auth: true}
    },
    {
      path: '/forget',
      name: 'forget',
      component: Forget,
      meta: {auth: false}
    },
    {
      path: '/reset_password',
      name: 'reset_password',
      component: ResetPassword
    },
    {
      path: '/confirm/:status',
      name: 'confirm',
      component: confirm
    },
    {
      path: '/404',
      name: '404',
      component: page404
    },
    {
      path: '/*',
      component: page404
    }
  ]
})
